import 'Styles/modals.scss';

import React from 'react';
import PropTypes from 'prop-types';

import {connect} from 'react-redux';
import { goBack } from 'react-router-redux';

import Modal from 'Components/modals/ModalComponent'

class ConfirmModalComponent extends React.Component {
	shouldComponentUpdate( nextProps ) {
		return ( nextProps.isOpen !== this.props.isOpen );
	}

	componentDidUpdate( prevProps ) {
		if( prevProps.isOpen === false && prevProps.isOpen !== this.props.isOpen ) {
			// using pushState to avoid popstate to be triggered
			history.pushState( { topifyExtra: true, type: 'confirmModal' }, '', window.location );
		}
	}

	hideModal = () => {
		if( this.props.isOpen ) {
			this.props.dispatch( goBack() );
		}
	};

	onOkClick = ( e ) => {
		let result = true;
		if( this.props.onOkClick ) {
			result = this.props.onOkClick( e );
		}

		if( result !== false ) {
			this.hideModal();
		}
	};

	onCancelClick = ( e ) => {
		if( this.props.onCancelClick ) {
			this.props.onCancelClick( e );
		}

		this.hideModal();
	};

	render() {
		return (
			<Modal isOpen={this.props.isOpen} onClickOutsideWindow={ this.hideModal } className="confirm-modal">
				<h2>{this.props.header}</h2>
				<div className="confirm-modal-content">{this.props.text}</div>

				<div className="modal-buttons">
					<button className="action-button" onClick={ this.onOkClick }>OK</button>
					<button className="cancel-button" onClick={ this.onCancelClick }>Cancel</button>
				</div>
			</Modal>
		);
	}
}

ConfirmModalComponent.propTypes = {
	isOpen: PropTypes.bool.isRequired,
	header: PropTypes.string,
	text: PropTypes.oneOfType( [
		PropTypes.string,
		PropTypes.object
	] ),
	onOkClick: PropTypes.func,
	onCancelClick: PropTypes.func
};

const mapStateToProps = ( state ) => {
	return {
		isOpen: state.ui.confirmModalOpened,
		header: state.ui.confirmModalOptions.header,
		text: state.ui.confirmModalOptions.text,
		onOkClick: state.ui.confirmModalOptions.action,
		onCancelClick: state.ui.confirmModalOptions.onCancel,
	}
};

export default connect( mapStateToProps )( ConfirmModalComponent );


// WEBPACK FOOTER //
// ./src/components/modals/ConfirmModalComponent.js